'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var buffer = require('buffer');
var mplCandyGuard = require('@metaplex-foundation/mpl-candy-guard');
var errors = require('../errors.cjs');
var Serializer = require('../../../types/Serializer.cjs');

/**
 * The thirdPartySigner guard requires a predefined
 * address to sign the mint transaction. The signer will need
 * to be passed within the mint settings of this guard.
 *
 * This allows for more centralized mints where every single
 * mint transaction has to go through a specific signer.
 *
 * This object defines the settings that should be
 * provided when creating and/or updating a Candy
 * Machine if you wish to enable this guard.
 *
 * @see {@link ThirdPartySignerGuardMintSettings} for more
 * information on the mint settings of this guard.
 */

/** @internal */
const thirdPartySignerGuardManifest = {
  name: 'thirdPartySigner',
  settingsBytes: 32,
  settingsSerializer: Serializer.createSerializerFromBeet(mplCandyGuard.thirdPartySignerBeet),
  mintSettingsParser: ({
    mintSettings
  }) => {
    if (!mintSettings) {
      throw new errors.GuardMintSettingsMissingError('thirdPartySigner');
    }
    return {
      arguments: buffer.Buffer.from([]),
      remainingAccounts: [{
        isSigner: true,
        address: mintSettings.signer,
        isWritable: true
      }]
    };
  }
};

exports.thirdPartySignerGuardManifest = thirdPartySignerGuardManifest;
//# sourceMappingURL=thirdPartySigner.cjs.map
